(()=>{
  "use strict";

  const downloadReport = () => {
    try {
      document.getElementById('report-action-plan').addEventListener('click', event => {
        event.preventDefault();
        let button = document.getElementById("report-action-plan"),
            href_report = new URL(window.location.origin + button.getAttribute('href'));

        href_report.searchParams.set('country', document.getElementById('country_id').value);
        href_report.searchParams.set('fesp', document.getElementById('survey_header_id').value);
        button.setAttribute('href', href_report.toString().replace(window.location.origin, ''))

        window.location = button.getAttribute('href');
      });
    } catch (error) {
      
    }
  };

  const duplicateGapContext = () => {
    $(document).on('click', '#duplicate-gap-context', e => {
      $(e.currentTarget).attr('disabled', 'disabled');
      let data = { 
        divided: true,
        evaluation_header_id: document.getElementById('gap-context-divided').getAttribute('data-evaluation'),
        unified_gap_id: document.getElementById('gap-context-divided').getAttribute('data-unified-gap'),
        gap_context: { 
          contextualization: $("#gap_context_contextualization").val(),
          observations: $("#gap_context_observations").val(),
        }
      };
      console.log(data);
      console.log(e.currentTarget.getAttribute('data-url-create'));
      
      try {
        fetch(e.currentTarget.getAttribute('data-url-create'), {
            method: 'POST',
            headers: new Headers({
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content
            }),
            body: JSON.stringify(data)
          })
          .then(json => json.json())
          .then(data => {
            swal('Context Duplicated');
            $('#modal-gap-contexts').modal('toggle');
            //location.href = `/action_plans/new?gap_context=${data.id}`;
          })
          .catch(error => {
            console.log(error);
            
            return error;
          });
      } catch (error) {
        swal('There was a problem trying to connect to the server to retrieve the necessary data, please try again; if the error persists please contact our staff.');
        console.log(error);
      }
    });
  };

  const loadGapContext = () => {
    $('#modal-gap-contexts').on('show.bs.modal', function (event) {
      let button = $(event.relatedTarget),
          evaluation = button.data('evaluation'),
          gap_context = button.data('gap-context');

      $("[data-btn-modal-save]").addClass('d-none');
      $(`#${button.data('button-id')}`).removeClass('d-none');

      fetch(`/evaluation_headers/${evaluation}/gap_contexts/${gap_context}.json`, {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content
        })
      })
      .then(json => json.json())
      .then(data => {
        $("#gap_context_contextualization").val(data.contextualization);
        $("#gap_context_observations").val(data.observations);
        try {
          document.getElementById('update-gap-context').setAttribute('data-url', `/evaluation_headers/${evaluation}/gap_contexts/${gap_context}.json`);
          document.getElementById('duplicate-gap-context').setAttribute('data-url', `/evaluation_headers/${evaluation}/gap_contexts/${gap_context}.json`);
          document.getElementById('duplicate-gap-context').setAttribute('data-url-create', `/evaluation_headers/${evaluation}/gap_contexts.json`);
        } catch (error) {
          
        }
      });
    })
  };

  const updatePriority = () => {
    $(document).on('change', '.action-plan-priority-update', e => {
      let data = { 
        action_plan: { 
          priority_id: e.currentTarget.value
        }
      },
      action_plan = e.currentTarget.getAttribute('id');

      try {
        return fetch(`/action_plans/${action_plan}.json`, {
            method: 'PUT',
            headers: new Headers({
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content
            }),
            body: JSON.stringify(data)
          })
          .then(json => json)
          .then(data => swal('Priority changed'))
          .catch(error => {
            console.log(error);
            
            return error;
          });
      } catch (error) {
        swal('There was a problem trying to connect to the server to retrieve the necessary data, please try again; if the error persists please contact our staff.');
        console.log(error);
      }
    });
  }

  const updatePrioritized = () => {
    document.addEventListener('change', element => {
      if (element.target.matches('input[data-update-prioritized]')) {
        let current_type_report = element.target.getAttribute('data-update-prioritized'),
            evaluation_header = element.target.getAttribute('data-evaluation-header'),
            url = `/evaluation_headers/${parseInt(evaluation_header)}/gap_contexts/${parseInt(current_type_report)}.json`,
            data = { gap_context: { prioritized: element.target.checked } };

        try {
          fetch(url, {
              method: 'PUT',
              headers: new Headers({
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content
              }),
              body: JSON.stringify(data)
            })
            .then(json => json.json())
            .then(info => {
              swal('Proceso Exitoso', 'Priorización actualizada', 'success');
            })
            .catch(error => {
              swal('Error', 'No se pudo actualizar la priorización', 'error');
              return error;
            });
        } catch (error) {
          swal('There was a problem trying to connect to the server to retrieve the necessary data, please try again; if the error persists please contact our staff.');
          console.log(error);
        }
      }
    });
  };

  const updateGapContext = () => {
    $(document).on('click', '#update-gap-context', e => {
      let data = { 
        gap_context: { 
          contextualization: $("#gap_context_contextualization").val(),
          observations: $("#gap_context_observations").val(),
        }
      };
      
      try {
        return fetch(e.currentTarget.getAttribute('data-url'), {
            method: 'PUT',
            headers: new Headers({
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content
            }),
            body: JSON.stringify(data)
          })
          .then(json => json.json())
          .then(data => {
            swal('Context Updated');
            location.reload();
          })
          .catch(error => {
            console.log(error);
            
            return error;
          });
      } catch (error) {
        swal('There was a problem trying to connect to the server to retrieve the necessary data, please try again; if the error persists please contact our staff.');
        console.log(error);
      }
    });
  }

  document.addEventListener('turbolinks:load', () => {
    updatePriority();
    loadGapContext();
    updateGapContext();
    duplicateGapContext();
    downloadReport();
    updatePrioritized();
  });
})();